window.QR = {
    html5QrCode: false,
    layout: {
        main_btn: $('#scan-qr'),
        camera: $('#camera'),
        cameraID: 0,
        camera_window: $('.camera-window'),
        cameras_list: $('.camera-window .cameras-list'),
        close: $('.camera-window .cross')
    },
    init: function () {

        if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
            window.QR.layout.main_btn.removeClass('hide');
        }

        window.QR.layout.main_btn.click(function () {
                window.QR.layout.camera_window.removeClass('hide');

                setTimeout(function () {
                    if(typeof Html5Qrcode != 'undefined') {
                        window.QR.layout.camera_window.addClass('active');

                        Html5Qrcode.getCameras().then(devices => {
                            if(devices && devices.length == 1) {

                            window.QR.layout.camera.removeClass('hide');
                            window.QR.layout.cameraID = devices[0].id;
                            window.QR.initCamera();

                        } else if (devices && devices.length > 1) {

                            if(window.QR.layout.cameraID == 0) {
                                var DEVICES_HTML = '';
                                $.each(devices, function (index, device) {
                                    DEVICES_HTML += '<div data-id="' + device.id + '" class="item"><div class="icon"><i class="far fa-camera"></i></div><div class="title">' + device.label + '</div><div class="clear"></div></div>';
                                });
                                window.QR.layout.cameras_list.html(DEVICES_HTML);
                                window.QR.layout.cameras_list.removeClass('hide');

                            } else {
                                window.QR.layout.camera.removeClass('hide');
                                window.QR.layout.cameraID = window.QR.layout.cameraID;
                                window.QR.initCamera();
                            }

                        } else {
                            window.QR.layout.main_btn.addClass('hide');
                        }



                        }).catch(err => {
                                window.QR.layout.main_btn.addClass('hide');
                        });
                    } else {
                        if(!window.QR.layout.main_btn.hasClass('hide')) {
                            window.QR.layout.main_btn.addClass('hide');
                        }
                    }
            }, 100);


        });

        window.QR.layout.close.click(function () {
            window.QR.layout.camera_window.removeClass('active');

            setTimeout(function () {
                window.QR.layout.camera_window.addClass('hide');

                if(!window.QR.layout.camera.hasClass('hide')) {
                    window.QR.layout.camera.addClass('hide')
                }

                if(!window.QR.layout.cameras_list.hasClass('hide')) {
                    window.QR.layout.cameras_list.addClass('hide')
                }

                if(window.QR.html5QrCode != false) {
                    window.QR.html5QrCode.stop();
                    window.QR.html5QrCode = false;
                }
            }, 300);
        });

        $('.camera-window .cameras-list').on("click", ".item", function () {
            window.QR.layout.camera.removeClass('hide');
            window.QR.layout.cameras_list.addClass('hide');
            window.QR.layout.cameraID = $(this).attr('data-id');
            window.QR.initCamera();
        });
    },

    initCamera() {
        window.QR.html5QrCode = new Html5Qrcode("camera");
        window.QR.html5QrCode.start(
            window.QR.layout.cameraID,
            {
                fps: 10,    // Optional frame per seconds for qr code scanning
            },
            qrCodeMessage => {

                var data = qrCodeMessage.split("?");
                if(data.length > 1) {
                    var items = data[1].split("&");

                    if(items.length > 0) {
                        var charger = items[0].split("=");
                        if(charger.length > 1) {
                            if(charger[0] == 'charger') {
                                var charger_pk = parseInt(charger[1]);
                                window.WS.getChargerInfo(charger_pk);
                                window.QR.layout.close.click();
                            }
                        }

                    }
                }

        },
            errorMessage => {}).catch(err => {});
    }
};
window.QR.init();